import * as types from '../constants/action-types';

function clearPayload () {
  return {
    type: types.PAYLOAD_CLEAR_STORE
  };
}

function updatePayloadSuccess (data) {
  return {
    type: types.PAYLOAD_UPDATE_SUCCESS,
    data
  };
}

export const updatePayload = (data) => {
  return dispatch => {
    dispatch(updatePayloadSuccess(data));
  };
};

export const clearPayloadStore = () => {
  return dispatch => {
    dispatch(clearPayload());
  };
};
